exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter__btn[data-v-0a228b6c]{border:none;max-width:288px;margin-left:-10px}.filter__btn button[data-v-0a228b6c]{padding:0 10px;border:2px solid #000;background:none;font-size:14px}.filter__btn button svg[data-v-0a228b6c]{margin-bottom:4px}.filter-btn[data-v-0a228b6c]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a228b6c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/artworks-contest/artworks-contest-root.vue
// module id = 5wTZ
// module chunks = 5